
export default {
  list: [],
  appointments: [],
  availableAppointments: {},
  appointmentsSurgeryCenter: [],
  proposedSurgeries: [],
  surgeries: [],
  anesthesia: []
}



// WEBPACK FOOTER //
// ./src/store/modules/schedule/state.js